import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

export const subscriptionUpgradeQueryKey = (petId: string) =>
  ['pet-subscription-upgrade', petId] as const

/**
 * Fetches available upgrade options for a pet's subscription via
 * `GET /api/portal/pets/:id/subscription/upgrade`. Returns prorated
 * amounts computed by Stripe for each target plan.
 *
 * Each fetch generates a preview invoice on Stripe, so we use a long
 * staleTime to avoid unnecessary API calls. The prorated total drifts
 * by fractions of a penny per hour, so staleness is cosmetic.
 * refetchOnWindowFocus overrides the global default (false) so that
 * a tab left open overnight still refreshes when the member returns.
 */
export function useGetSubscriptionUpgrade(petId: string | null | undefined) {
  const api = usePortalApi()
  return useQuery({
    queryKey: subscriptionUpgradeQueryKey(petId ?? ''),
    enabled: !!petId,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
    queryFn: async () =>
      dataOrThrow(await api.get('/pets/:id/subscription/upgrade', { params: { id: petId ?? '' } })),
  })
}
